import { apiEmpleo } from "../../util/ApiEmpleo";

const apiExpandContractPrefilter = async (contractId: string) => {
  const res = await apiEmpleo.post(
    `contracts/${contractId}/prefilter/expand`
  );

  return res;
};

export { apiExpandContractPrefilter };
